// StyledPermissionTable.tsx
import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Switch, Tooltip, } from "@mui/material";
import useTableStyles from "./useTableStyles";
const DEFAULT_PERMISSIONS = [
    "read",
    "update",
    "create",
    "delete",
];
const StyledPermissionTable = ({ rows, permissions = DEFAULT_PERMISSIONS, rolePermissions, onChange, isDisabled = () => false, t, isAllDisabled = false, }) => {
    const styles = useTableStyles();
    const isDeleteRestricted = (module, permission) => permission === "delete" &&
        ["roles", "vdkevents"].includes(module.toLowerCase());
    return (React.createElement(TableContainer, { sx: styles.tableContainer },
        React.createElement(Table, { stickyHeader: true, "aria-label": "styled permission table" },
            React.createElement(TableHead, null,
                React.createElement(TableRow, { sx: styles.headerRow },
                    React.createElement(TableCell, { sx: styles.firstHeadCell }, t("modules:rolesPermissions.modules")),
                    permissions.map((permission) => (React.createElement(TableCell, { key: permission, align: "center", sx: styles.headCell }, t(`modules:rolesPermissions.${permission}`)))))),
            React.createElement(TableBody, null, rows.map((module) => (React.createElement(TableRow, { key: module, sx: styles.bodyRow },
                React.createElement(TableCell, { sx: styles.moduleCell }, t(`modules:modulesList.${module.toLowerCase()}`)),
                permissions.map((permission, index) => {
                    var _a;
                    const disabled = isDeleteRestricted(module, permission) ||
                        isDisabled(module, index) ||
                        isAllDisabled;
                    const switchElement = !isDeleteRestricted(module, permission) ? (React.createElement(Switch, { checked: ((_a = rolePermissions[module]) === null || _a === void 0 ? void 0 : _a[permission]) || false, onChange: (e) => onChange(module, permission, e.target.checked), disabled: disabled, color: "primary" })) : null;
                    return (React.createElement(TableCell, { align: "center", key: `${module}-${permission}`, sx: styles.switchCell }, isDeleteRestricted(module, permission) ? (React.createElement(Tooltip, { title: t("actions.notAllowed"), arrow: true },
                        React.createElement("span", null, switchElement))) : (switchElement)));
                }))))))));
};
export default StyledPermissionTable;
